import Player from "./player";

export default class Session {
    id!: string;
    createdAt!: Date;
    name!: string;
    description!: string;
    universeName!: string;
    universeId!: string;
    campaignName!: string;
    campaignId!: string;
    masterId!: string;
    maxPlayers: number = 0;
    players: Player[] = [];


    constructor(data?: any) {
        if (data) {
            if (typeof data !== "object") data = JSON.parse(data);
            Object.assign(this, data);
            this.players = Array.isArray(data.players)
                ? data.players.map((player: any) => new Player(player))
                : [];
            this.maxPlayers =
                typeof data.maxPlayers === 'number'
                    ? data.maxPlayers
                    : this.players.length;
        } else {
        }
    }
}
